export const getClassNames = (classNames: string[]) => {
  return classNames.join(' ').trim();
};
